module.exports = __webpack_public_path__ + "static/media/Novideo.fdca85a8.png";